export interface IDistrict {
  id: number;
  code: string;
  postalSector: string;
  name: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}
